<template>
  <NuxtLayout name="default">
    <NotFound></NotFound>
  </NuxtLayout>
</template>

<script lang="ts" setup></script>

<style></style>
